module.exports = __webpack_public_path__ + "fonts/GlacialIndifference.de2345cf.eot";